import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'src.pages.ErrorPopUp.title',
    defaultMessage: 'Uh oh! Something went wrong.',
  },
  textNoSave: {
    id: 'src.pages.ErrorPopUp.textNoSave',
    defaultMessage: 'Uh oh! Something went wrong. Please try again later or give us a call at ',
  },
  textSave: {
    id: 'src.pages.ErrorPopUp.textSave',
    defaultMessage: 'Uh oh! Something went wrong. Don\'t worry we\'ve saved your progress. Please try again later or give us a call at ',
  },
  btn: {
    id: 'src.pages.ErrorPopUp.btn',
    defaultMessage: 'Return to dashboard',
  },
  callUs: {
    id: 'src.pages.ErrorPopUp.callUs',
    defaultMessage: 'Call us',
  },
  phoneNumber: {
    id: 'src.pages.ErrorPopUp.phoneNumber',
    defaultMessage: '1-844-766-6384',
  },
  enterpriseTitle: {
    id: 'src.pages.ErrorPopUp.enterpriseTitle',
    defaultMessage: 'Sorry, we\'re having trouble connecting to Enterprise',
  },
  enterpriseText: {
    id: 'src.pages.ErrorPopUp.enterpriseText',
    defaultMessage: 'You can still call your nearest Enterprise location to book a car rental comparable in size and seating to your insured vehicle. You can also choose another available option. Remember, a Claims team member will review your claim and determine coverage no matter which option you choose.',
  },
  audatargetTitle: {
    id: 'src.pages.ErrorPopUp.audatargetTitle',
    defaultMessage: 'Uh oh! Something went wrong.',
  },
  audatargetText: {
    id: 'src.pages.ErrorPopUp.audatargetText',
    defaultMessage: 'Please try again or give us a call at 1-844-766-6384. You can also continue with your claim and a Claims team member will arrange this for you later.',
  },
  okay: {
    id: 'src.pages.ErrorPopUp.okay',
    defaultMessage: 'Okay',
  },
  cancel: {
    id: 'src.pages.ErrorPopUp.cancel',
    defaultMessage: 'Cancel',
  },
});
